<nz-spin [nzSpinning]="loading$ | async"
  ><form
    [formGroup]="organizationUserForm"
    (ngSubmit)="onSubmit()"
    nz-form
    class="user-form form"
    nzLayout="vertical">
    <div class="drawer-form-wrapper">
      <div class="form-grid-secondary">
        <nz-form-item>
          <nz-form-label nzFor="email" nzRequired>Username</nz-form-label>
          <nz-form-control [nzErrorTip]="emailErrorTpl">
            <input
              name="email"
              type="text"
              nz-input
              id="email"
              formControlName="email"
              placeholder="Enter your user name" />
            <ng-template #emailErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please enter your username.
              </ng-container>
              <ng-container
                *ngIf="
                  control.hasError('email') || control.hasError('pattern')
                ">
                Please enter a valid username.
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="firstName" nzRequired>First Name</nz-form-label>
          <nz-form-control [nzErrorTip]="firstNameErrorTpl">
            <input
              name="warningValid"
              type="text"
              nz-input
              id="firstName"
              formControlName="firstName"
              placeholder="Enter your first name" />
            <ng-template #firstNameErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please enter your first name.
              </ng-container>
              <ng-container *ngIf="control.hasError('minlength')">
                First name must be at least 2 characters.
              </ng-container>
              <ng-container *ngIf="control.hasError('maxlength')">
                First name cannot exceed 50 characters.
              </ng-container>
              <ng-container *ngIf="control.hasError('pattern')">
                Spaces are not allowed at the start or end.
              </ng-container>
              <ng-container
                *ngIf="
                  control.hasError('empty') &&
                  !control.hasError('minlength') &&
                  !control.hasError('maxlength')
                ">
                Please enter a valid first name!
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="lastName" nzRequired>Last Name</nz-form-label>
          <nz-form-control [nzErrorTip]="lastNameErrorTpl">
            <input
              name="warningValid"
              type="text"
              nz-input
              id="lastName"
              formControlName="lastName"
              placeholder="Enter your last name" />
            <ng-template #lastNameErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please enter your last name.
              </ng-container>
              <ng-container *ngIf="control.hasError('minlength')">
                Last name must be at least 2 characters.
              </ng-container>
              <ng-container *ngIf="control.hasError('maxlength')">
                Last name cannot exceed 50 characters.
              </ng-container>
              <ng-container *ngIf="control.hasError('pattern')">
                Spaces are not allowed at the start or end.
              </ng-container>
              <ng-container
                *ngIf="
                  control.hasError('empty') &&
                  !control.hasError('minlength') &&
                  !control.hasError('maxlength')
                ">
                Please enter a valid last name.
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item class="col-span">
          <nz-form-label nzFor="titleId" nzRequired>Title</nz-form-label>
          <nz-form-control nzErrorTip="Please select your title.">
            <nz-select
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              id="titleId"
              formControlName="titleId"
              nzPlaceHolder="Select a title"
              name="title"
              (ngModelChange)="onTitleChange($event)">
              @for (title of titleList; track title) {
                <nz-option
                  [nzLabel]="title.title"
                  [nzValue]="title.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item class="col-span">
          <nz-form-label nzFor="statusId" nzRequired>Status</nz-form-label>
          <nz-form-control nzErrorTip="Please select your status.">
            <nz-select
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select a status"
              formControlName="statusId"
              name="statusId">
              @for (status of statusList; track status) {
                <nz-option
                  [nzLabel]="status.value | titlecase"
                  [nzValue]="status.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <h3 class="title s-18 mb-16">User Roles</h3>
      <nz-spin [nzSpinning]="(isLoading | async) ?? false">
        <nz-table
          #rowSelectionTable
          [nzData]="cachedRoleList"
          [nzFrontPagination]="false"
          (nzCurrentPageDataChange)="onCurrentPageDataChange()"
          nzShowPagination="false">
          <thead>
            <tr>
              <th
                scope="col"
                nzWidth="60px"
                [nzSelections]="listOfSelection"
                [(nzChecked)]="checked"
                [nzDisabled]="isDisableAllCheckBox"
                [nzIndeterminate]="indeterminate"
                (nzCheckedChange)="onAllChecked($event)"></th>
              <th scope="col">User Roles</th>
            </tr>
          </thead>
          <tbody>
            @if (cachedRoleList.length === 0) {
              <tr>
                <td colspan="2" class="extra-text">No roles found</td>
              </tr>
            }
            <tr
              *ngFor="
                let data of rowSelectionTable.data;
                trackBy: trackByRoleId
              ">
              <td
                [nzChecked]="setOfCheckedId.has(data.id)"
                [nzDisabled]="isDisableAllCheckBox"
                (nzCheckedChange)="onItemChecked(data.id, $event)"></td>
              <td>
                {{ data.name }}
                <svg-icon
                  *ngIf="getRoleDescription(data.name)"
                  nz-tooltip
                  [nzTooltipTitle]="getRoleDescription(data.name)"
                  src="/assets/icon/icon-help.svg"
                  class="icon s-12 ml-6"
                  aria-label="Help">
                </svg-icon>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </nz-spin>
      <div class="display-flex justify-content-between drawer-footer">
        <button
          nz-button
          type="button"
          nzType="default"
          (click)="closeDrawer()">
          Cancel
        </button>
        <button
          nz-button
          type="submit"
          nzType="primary"
          [nzLoading]="loading"
          [disabled]="!organizationUserForm.valid">
          Add User
        </button>
      </div>
    </div>
  </form>
</nz-spin>
